import React from "react";

import { useAtom } from "jotai";
import { darkThemeAtom } from "../../atoms";

import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import { Radio } from "@material-ui/core";

import Card from "@material-ui/core/Card";
import { CardHeader, Typography, CardContent, CardActionArea } from "@material-ui/core";
import { Avatar } from "@material-ui/core";
import { Box } from "@material-ui/core";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import { IconButton } from "@material-ui/core";
import { Grid } from "@material-ui/core";

import cy from "../images/testimonials/ChrisYang.jpg";
import dt from "../images/testimonials/DmitryTysh.jpg";
import eb from "../images/testimonials/EmmanuelBaja.jpg";
import jn from "../images/testimonials/JohnNguyen.jpg";
import ob from "../images/testimonials/OmsriBharat.jpg";
import sp from "../images/testimonials/StephanPetrequin.jpg";

import { MYCOLORS } from "../../mypallette";

import { useTestimonialsStyles } from "./TestimonialStyles";

const cardData = [
  {
    name: "Chris Yang",
    image: cy,
    quote:
      "Phu is an asset to any team he is on. He has in-depth knowledge and experience leading complex projects with a sharp focus on delivering business value to his end-users. Working with Phu on strategic partnership evaluation projects allowed me to learn ways to manage stakeholder expectations, handle risk, and break down ambiguous business goals through logical actionable steps. Phu is a passionate project manager that would also spend time to mentor others around him. It was a joy working with Phu, and I look forward to working with him again.",
    role: "Product Manager",
    linkedin: "https://www.linkedin.com/in/cyang93/",
  },
  {
    name: "Dmitry Tysh",
    image: dt,
    quote:
      "Phu and I worked together at OSIsoft. Phu is an excellent Project Manager. He possess the critical skills to effectively manage complex projects. He pays close attention to all intricacies of a project and goes above and beyond to deliver quality product, stay on target and within the budget. Phu completely understands the SDLC and how to convert those principles to best practices within the product development environment.",
    role: "Solutions Architect / Sr Software Developer",
    linkedin: "https://www.linkedin.com/in/dmitry-tysh/",
  },
  {
    name: "Emmanuel Baja",
    image: eb,
    quote:
      "Phu was an exceptional Project Manager to work with, and was able to understand both our processes and pain points real quickly in our customer care group. He was an exceptional resource to have as an advisor and SME. I know he would be an exceptional asset for any group he works with. I would highly recommend Phu to any organization looking for a team player who is communicative, organized, and quick on the understanding of complex system processes.",
    role: "Sr Sales Operations Analyst",
    linkedin: "https://www.linkedin.com/in/emmanuel-baja-4594a66/",
  },
  {
    name: "John Nguyen",
    image: jn,
    quote:
      "Phu will be a great asset to any team. He is not only smart but is a true critical thinker who assesses all aspects of a situation (technical, human, business, etc.) to bring good judgment and decision-making in projects. On top of that, he actually cares about people while always seeking business value.",
    role: "Project Manager / Developer",
    linkedin: "https://www.linkedin.com/in/john-nguyen-82215a5/",
  },
  {
    name: "Omsri Bharat",
    image: ob,
    quote:
      "Phu is a great team member and friend. He has been a mentor since I started at OSIsoft - he is always willing to sit down and talk about how to tackle any unique challenges that have come up and offer his expertise in project management and business processes to create the desired outcome. He is detail-oriented and has an exceptional knowledge of how teams work, how to create processes that are sustainable and bring value to the business, and how to work with teams to achieve results. Apart from that, he is always friendly and willing to bring new people into a team and make them feel welcome.",
    role: "Consultant",
    linkedin: "https://www.linkedin.com/in/omsri-bharat-0689b997/",
  },
  {
    name: "Stephan Petrequin",
    image: sp,
    quote:
      "Phu's attention to detail and enthusiasm for every project made it a joy to have him on our team. His ability to understand complex business requirements helped us immensely in architecting, problem solving, and task creation. His communication skills helped discover issues before they become problems and fostered trust. I wholeheartedly recommend Phu as a PM on any complex project.",
    role: "Sr Programmer Analyst",
    linkedin: "https://www.linkedin.com/in/stephanpetrequin/",
  },
];

const Testimonials = () => {
  const classes = useTestimonialsStyles();


  const [currentSlide, setCurrentSlide] = React.useState(2);

  const [sliderRef, slider] = useKeenSlider({
    slidesPerView: 2,
    initial: 2,
    mode: "free-snap",
    spacing: 0,
    centered: true,
    loop: false,
    breakpoints: {
      "(min-width: 0px) and (max-width: 600px)": {
        slidesPerView: 1,
        centered: false,
      },
    },
    slideChanged(s) {
      setCurrentSlide(s.details().relativeSlide);
    },
  });

  const [darkTheme] = useAtom(darkThemeAtom);

  //various sub Card elements explained: https://react.school/material-ui/card
  return (
    <>
      <Card  className={darkTheme ? classes.cardmainDark : classes.cardmainLight} elevation={4}>
        <CardHeader
          title={
            <Typography
              align='center'
              variant='h4'
              style={{ color: darkTheme ? MYCOLORS.dhighlight : MYCOLORS.lhighlight }}
            >
              Testimonials
            </Typography>
          }
        ></CardHeader>
        <div ref={sliderRef} className='keen-slider' style={{ margin: "0px" }}>
          {cardData.map((e, i) => {
            return (
              <div key={i} className='keen-slider__slide number-slide1'>
                <Box className={classes.boxcontainer}>
                  <CardActionArea className={classes.actionArea} disableRipple>
                    <Card elevation={4} className={darkTheme ? classes.innerCardDark : classes.innerCardLight}>
                      <Box display='flex' justifyContent='center' alignItems='center' mt={3}>
                        <Avatar alt={cardData[i]["name"]} src={cardData[i]["image"]} className={classes.large} />
                      </Box>
                      <CardContent>
                        <Grid
                          container
                          alignItems='flex-start'
                          spacing={0}
                          wrap='nowrap'
                          direction='row'
                          justifyContent='center'
                        >
                          <Grid item>
                            <Typography component='span' variant='h1' color='secondary'>
                              “
                            </Typography>
                          </Grid>
                          <Grid item>
                            <div style={{ visibility: "hidden", margin: 5 }}>invisble div</div>
                            <Typography component='span' variant='body2'>
                              {cardData[i]["quote"]}”
                            </Typography>
                          </Grid>
                        </Grid>

                        <CardContent>
                          <Grid container alignItems='center' justifyContent='center' spacing={1}>
                            <Grid item>
                              <Typography align='center' variant='subtitle1' component='span'>
                                {cardData[i]["name"]}
                              </Typography>
                            </Grid>
                            <Grid item>
                              <IconButton
                                size='small'
                                color='secondary'
                                href={cardData[i]["linkedin"]}
                                target='_blank'
                                rel='noreferrer'
                              >
                                <LinkedInIcon />
                              </IconButton>
                            </Grid>
                          </Grid>

                          <Typography align='center' variant='body2' component='p'>
                            {cardData[i]["role"]}
                          </Typography>
                        </CardContent>
                      </CardContent>
                    </Card>
                  </CardActionArea>
                </Box>
              </div>
            );
          })}
        </div>

        {slider && (
          <Box align='center' alignContent='center'>
            {[...Array(slider.details().size).keys()].map((idx) => {
              return (
                <Radio
                  key={idx}
                  checked={currentSlide === idx}
                  onChange={() => {
                    slider.moveToSlideRelative(idx);
                  }}
                  size='small'
                  inputProps={{ "aria-label": { idx } }}
                />
              );
            })}
          </Box>
        )}

        <div style={{ visibility: "hidden" }}>invisble div</div>
        <div style={{ visibility: "hidden" }}>invisble div</div>
      </Card>
    </>
  );
};

export default Testimonials;
